import { Stack, Typography, useTheme } from "@mui/material";
import { CheckCircleIcon } from "components";

export const CheckboxItem = ({
  label,
  isChecked,
  onClick,
}: {
  label: string;
  isChecked: boolean;
  onClick: () => void;
}) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      alignItems={"center"}
      justifyContent={"space-between"}
      gap="8px"
      border={`1px solid ${
        isChecked ? theme.palette.primary.main : theme.palette.neutral["015"]
      }`}
      bgcolor={isChecked ? theme.palette.neutral["B-005"] : "transparent"}
      p="14px 16px"
      borderRadius="8px"
      flex={1}
      sx={{
        cursor: "pointer",
        transition: "all 0.3s",
        userSelect: "none",
        ":hover": {
          bgcolor: theme.palette.neutral["B-005"],
        },
      }}
      onClick={onClick}
    >
      <Typography
        variant="body-medium"
        color={{
          color: isChecked
            ? theme.palette.primary.main
            : theme.palette.lightBg.low,
        }}
      >
        {label}
      </Typography>
      <CheckCircleIcon
        color="primary"
        style={{
          width: "24px",
          height: "24px",
          marginTop: "2px",
          visibility: isChecked ? "visible" : "hidden",
        }}
      />
    </Stack>
  );
};
